// Base URL for assets
//const BASE_URL = import.meta.env.BASE_URL || '';

// Remove the image imports since we're using public paths
export const investmentsData = [
  {
    company: "Elliptic",
    logoSrc: `/images/elliptic-logo.png`,
    stage: "Series C",
    description:
      "Elliptic is the leading provider of blockchain analytics and crypto compliance solutions. Their platform helps banks, crypto businesses, and regulators detect and prevent financial crime across digital assets — screening wallets and transactions for links to illicit activity in real time across more than 100 blockchains.",
    coInvestors: [
      "Evolution Equity Partners",
      "SoftBank Vision Fund 2",
      "Wells Fargo Strategic Capital",
      "SBI Group",
      "AlbionVC",
    ],
  },
  {
    company: "Prophecy.io",
    logoSrc: `/images/prophecy-logo.png`,
    stage: "Series B",
    description:
      "Prophecy is a low-code data engineering platform that makes it easy to develop, deploy, and maintain data pipelines on Apache Spark. Their visual interface allows engineers to build complex data transformations with a drag-and-drop approach while automatically generating high-quality code.",
    coInvestors: [
      "Insight Partners",
      "SignalFire",
      "SmithPoint Capital",
      "JP Morgan Chase",
    ],
  },
  {
    company: "TechWolf.ai",
    logoSrc: `/images/techwolf-logo.png`,
    stage: "Series B",
    description:
      "TechWolf is an AI-powered skills intelligence platform that helps organizations understand, map, and develop their talent's skills. Their technology analyzes employees' skills from various data sources to create a real-time skills inventory, enabling better workforce planning.",
    coInvestors: [
      "Felix Capital",
      "Stride.VC",
      "Notion Capital",
      "Workday Ventures",
      "20VC",
    ],
  },
  {
    company: "Marketnode",
    logoSrc: `/images/marketnode-logo.png`,
    stage: "Series A",
    description:
      "Marketnode is a digital asset infrastructure provider focused on capital markets. Their platform offers end-to-end solutions for issuance, registry, custody, and post-trade management of digital securities, helping financial institutions transition to blockchain-based infrastructure.",
    coInvestors: ["Temasek", "SGX", "Euroclear"],
  },
  {
    company: "Nova Credit",
    logoSrc: `/images/nova-credit-logo.png`,
    stage: "Series C",
    description:
      "Nova Credit is a cross-border credit reporting agency that helps immigrants bring their credit history with them when they move to a new country. Their Credit Passport® technology enables lenders to use a person's foreign credit data to evaluate applications for credit products.",
    coInvestors: [
      "Kleiner Perkins",
      "Canapi Ventures",
      "Index Ventures",
      "General Catalyst",
    ],
  },
  {
    company: "Classiq",
    logoSrc: `/images/classiq-logo.png`,
    stage: "Series B",
    description:
      "Classiq has built the world's leading quantum software development platform that automates the entire process of creating quantum software. Their technology allows developers to build sophisticated quantum applications without writing complex quantum circuits.",
    coInvestors: ["HPE", "Samsung Ventures", "Wing Capital", "Team8 Capital"],
  },
  {
    company: "Tree Energy Services",
    logoSrc: `/images/tes-logo.png`,
    stage: "Growth",
    description:
      "Tree Energy Services (TES) is pioneering clean hydrogen and carbon removal solutions for hard-to-abate industries. Their innovative technology captures CO2 emissions and converts them into clean energy carriers, helping heavy industries achieve decarbonization goals.",
    coInvestors: ["E.ON", "UniCredit", "Zodiac Maritime"],
  },
  {
    company: "Monese",
    logoSrc: `/images/monese-logo.png`,
    hoverLogoSrc: `/images/xyb-logo.png`,
    stage: "Growth",
    description:
      "Monese provides accessible banking services for customers who might be overlooked by traditional banks. Their digital banking platform makes it easy for mobile customers, including migrants and expats, to open a banking account instantly, regardless of their financial history or residence.",
    coInvestors: [
      "Outward Ventures (Investec)",
      "PayPal Ventures",
      "Kinnevik",
      "Augmentum Fintech",
    ],
  },
  {
    company: "Contextual.ai",
    logoSrc: `/images/contextual-logo.png`,
    stage: "Series A",
    description:
      "Contextual.ai is developing next-generation AI systems for understanding and generating human language. Their technology helps enterprises build applications that can process, analyze, and generate text that understands nuanced context, leading to more natural interactions.",
    coInvestors: [
      "Greycroft",
      "Lightspeed",
      "Bain Capital Ventures",
      "NVidia",
      "Sarah Guo",
    ],
  },
];
